type ParsedValue =
  | { type: "V"; num: number }
  | { type: "SP" }
  | { type: "M"; num: number }
  | { type: "OTHER"; value: string };

const orderPriority: Record<"V" | "SP" | "M" | "OTHER", number> = {
  V: 1,
  SP: 2,
  M: 3,
  OTHER: 4,
};

const parseValue = (val: string): ParsedValue => {
  if (val.startsWith("V")) {
    return { type: "V", num: parseInt(val.slice(1), 10) };
  } else if (val === "SP") {
    return { type: "SP" };
  } else if (val.startsWith("M")) {
    return { type: "M", num: parseInt(val.slice(1), 10) };
  }
  return { type: "OTHER", value: val };
};

export const conditionSorter = (a: string, b: string): number => {
  const aParsed = parseValue(a);
  const bParsed = parseValue(b);

  // タイプの優先順位で比較
  if (orderPriority[aParsed.type] !== orderPriority[bParsed.type]) {
    return orderPriority[aParsed.type] - orderPriority[bParsed.type];
  }

  // 同じタイプの場合、数字があるものは数値で比較
  if (aParsed.type === "V" && bParsed.type === "V") {
    return aParsed.num - bParsed.num;
  }
  if (aParsed.type === "M" && bParsed.type === "M") {
    return aParsed.num - bParsed.num;
  }
  if (aParsed.type === "OTHER" && bParsed.type === "OTHER") {
    return aParsed.value.localeCompare(bParsed.value);
  }

  return 0;
};
